import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCommonModule } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NgOtpInputModule } from 'ng-otp-input';
import { MaterialAngularModule } from 'src/app/material-design/material.module';
import { SharedDirectivesModule } from '../directives/shared-directives.module';
import { AlertComponent } from './alert/alert.component';
import { ConfirmatonModalComponent } from './confirmaton-modal/confirmaton-modal.component';
import { HeaderComponent } from './layout/header/header/header.component';
import { ModalWrapperComponent } from './modal-wrapper/modal-wrapper.component';
import { SkeletonComponent } from './skeleton/skeleton.component';
import { SharedPipesModule } from '../pipes/shared-pipes.module';
import { ValidacaoCadastroModalComponent } from './validacao-cadastro-modal/validacao-cadastro-modal.component';
import { InternalHeaderComponent } from './layout/header/internal-header/internal-header.component'
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';

@NgModule({
  declarations: [
    ValidacaoCadastroModalComponent,
    ModalWrapperComponent,
    ConfirmatonModalComponent,
    AlertComponent,
    HeaderComponent,
    SkeletonComponent,
    InternalHeaderComponent,
    BreadcrumbComponent
  ],
  imports: [
    CommonModule,
    MaterialAngularModule,
    MatCommonModule,
    BrowserModule,
    NgOtpInputModule,
    FormsModule,
    SharedDirectivesModule,
    ReactiveFormsModule,
    RouterModule,
    SharedPipesModule,
  ],
  exports: [
    AlertComponent,
    HeaderComponent,
    SkeletonComponent,
    InternalHeaderComponent,
  ],
})
export class ComponentsModule {}
